import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 500 500"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M500 166.772c0-80.289-65.083-145.366-145.361-145.366-40.972 0-77.961 16.977-104.389 44.25l-.256-.256-.25.25c-26.427-27.267-63.411-44.239-104.377-44.239C65.083 21.406 0 86.483 0 166.772c0 40.972 16.978 77.956 44.244 104.378l205.75 207.444L455.755 271.15C483.022 244.728 500 207.739 500 166.772",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }